import './unapplied_date_filter_type_selector_view.js.coffee';# Added by Script 
import '../../../../models/customer/visual_mode/filters/last_interval/last_interval_options.js.coffee'
Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedDateRealtimeFilterTypeSelectorView extends
CustomerVisualMode.Filters.Unapplied.UnappliedDateFilterTypeSelectorView

  initialize: ({isChecked, value}) ->
    @isChecked = isChecked
    @value = value
    @name = I18n.t('monitoring.dashboard.filters.filter_names.time.realtime')
    @type = 'realtime'

  _renderModifier: ->
    @selectView?.remove()
    @selectView = new Common.SelectView(
      options: @_selectorOptions()
      selectedOption: @value
    )
    @$('.value-group-modifiers').empty().append @selectView.render().el

  selectedModifier: ->
    @selectView.getSelectedOption()

  toggleSelector: ->
    @selectView.toggleSelector(@$('.date-filter-type').is(':checked'))

  _selectorOptions: ->
    [].concat(
      @_currentDayOption(),
      @_lastIntervalOptions(),
      @_allHistoryOption()
    )

  _displayValue: (type) ->
    I18n.t("customer_visual_mode.filters.date.#{type}")

  _lastIntervalOptions: ->
    lastIntervalOptions = new CustomerVisualMode.Filters.LastInterval.LastIntervalOptions()
    lastIntervalOptions.options().map((option) ->
      {
        type: CustomerVisualMode.Filters.DateFilter.TYPES.LAST_INTERVAL,
        time_interval_in_seconds: option.interval,
        value: option.interval,
        label: option.name
      }
    )

  _buildOption: (option) ->
    {
      type: option,
      value: option,
      label: @_displayValue(option)
    }

  _currentDayOption: ->
    @_buildOption(CustomerVisualMode.Filters.DateFilter.TYPES.CURRENT_DAY)

  _allHistoryOption: ->
    @_buildOption(CustomerVisualMode.Filters.DateFilter.TYPES.ALL_HISTORY)
